function getScrollbarSize(doc) {
  const documentWidth = doc.documentElement.clientWidth;
  return Math.abs(window.innerWidth - documentWidth);
}
export {
  getScrollbarSize as default
};
//# sourceMappingURL=getScrollbarSize.es.js.map
